<template>
  <div>
    <img src='../assets/logo.png' id='logo'>
    <br>
    <el-autocomplete
      popper-class='gsh-autocomplete'
      :fetch-suggestions='querySearchAsync'
      v-model='state'
      custom-item='gsh-item-zh'
      placeholder='作品名称或作者姓名'
      @select='handleSelect'
      size='large'
      icon='search'
      :on-icon-click='handleIconClick'>
    </el-autocomplete>
  </div>
</template>

<style lang='scss'>
  .gsh-autocomplete {
    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;

    li {
      line-height: normal;
      padding: 6px !important;

      .name {
        padding: 0px !important;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .sub-title {
        padding: 0px !important;
        font-size: 12px;
        color: #b4b4b4;
      }

      .highlighted .sub-title {
        color: #ddd;
      }
    }
  }

  #logo {
    padding-top: 10%;
    width: 180px;
  }
</style>

<script>
  import { postKeyword, postVisitedGSH, getMetaByKeyword } from '../api/index'
  import Vue from 'vue'
  import _ from 'lodash'

  Vue.component('gsh-item-zh', {
    functional: true,
    render: function (h, ctx) {
      let item = ctx.props.item
      for (let key in item) {
        if (item[key] == null) {
          item[key] = ''
        }
      }
      return h('li', ctx.data, [
        h('div', {attrs: {class: 'name'}}, [item.value]),
        h('span', {attrs: {class: 'sub-title'}}, [item.dynasty + ' ' + item.author + ' ' + item.material + ' ' + item.form + ' ' + item.museum])
      ])
    },
    props: {
      item: {type: Object, required: true}
    }
  })

  export default {
    name: 'search',
    data () {
      return {
        state: ''
      }
    },
    methods: {
      querySearchAsync (queryString, cb) {
        if (queryString !== '') {
          getMetaByKeyword(queryString).then(value => {
            let searchList = value.result.filter((e, i, a) => {
              // 关键字查找并过滤重复作品
              return (e.name.indexOf(queryString) !== -1 || e.author.indexOf(queryString) !== -1) &&
                _.findIndex(a, o => o.name === e.name && o.author === e.author) === i
            })
            this.$store.commit('setSearchList', searchList)
            searchList = searchList.map(e => {
              return {
                value: e.name,
                author: e.author,
                md5: e.md5,
                dynasty: e.dynasty,
                form: e.form,
                material: e.material,
                museum: e.museum,
                width: e.width,
                height: e.height
              }
            })
            cb(
              searchList
            )
          })
          postKeyword(queryString)
        } else {
          cb([])
        }
      },
      handleSelect (item) {
        this.$router.push({name: 'canvas-gsh', params: {md5: item.md5}})
        postVisitedGSH(item.md5, item.value, item.author)
      },
      handleIconClick (ev) {
        let queryString = this.state
        postKeyword(queryString)
        this.$router.push({name: 'waterfall'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Search.vue?7a11b3b2